module.exports = __webpack_public_path__ + "img/IMG_8966.0e726cbb.jpg";